import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService, HttpOptions } from '@ipg/ngx-frontend-toolset';

export interface AvailableModelInfo {
  /** The Scaleway model id, shown verbatim as the dropdown label. */
  id: string;
  description: string;
  recommended: boolean;
}

export interface AgentSettingDetail {
  agentName: string;
  label: string;
  description: string;
  model: string;
  defaultModel: string;
  systemPrompt: string;
  systemPrompts?: Record<string, string>;
}

export interface AiAgentSettingsResponse {
  availableModels: AvailableModelInfo[];
  agents: Record<string, AgentSettingDetail>;
}

export interface AgentModelUpdate {
  model: string;
}

export interface AiAgentSettingsUpdateRequest {
  agents: Record<string, AgentModelUpdate>;
}

@Injectable({
  providedIn: 'root',
})
export class AiAgentSettingsService {
  private readonly _backend = inject(BackendService);

  getSettings(options?: HttpOptions): Observable<AiAgentSettingsResponse> {
    return this._backend.get<AiAgentSettingsResponse>('/ai-agent-settings', options);
  }

  updateSettings(
    payload: AiAgentSettingsUpdateRequest,
    options?: HttpOptions
  ): Observable<AiAgentSettingsResponse> {
    return this._backend.patch<AiAgentSettingsResponse>(
      '/ai-agent-settings',
      payload,
      options
    );
  }
}
